// stores/empresa.js
import { defineStore } from "pinia";

const ruta_api = process.env.VUE_APP_ROOT_API;

export const useEmpresa = defineStore({
  id: "empresa",
  state: () => ({
    empresa: localStorage.getItem("empresa")
      ? JSON.parse(localStorage.getItem("empresa"))
      : null,
  }),
  actions: {
    async getEmpresa() {
      // Si ya está cargada, no hacer nada
      if (this.empresa?.id) {
        return;
      }

      const res = await fetch(ruta_api + "/empresa", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const output = await res.json();

      if (output.res) {
        localStorage.setItem("empresa", JSON.stringify(output.data));
        this.empresa = output.data;
      } else {
        alert(output.message);
      }
    },
  },
});